/** Assistant and placement keys are underscore-only; a typed or pasted "-" becomes "_". */
export function toUnderscoreKey(value: string): string {
  return value.replace(/-/g, '_');
}

export const KEY_DASH_HINT =
  'Only underscores (_) are accepted. Dashes (-) are automatically replaced with underscores (_).';

/** The new-placement key rule: the edit pattern minus "-". Edit keeps `PLACEMENT_KEY_PATTERN` so legacy dash keys still save. */
export const CREATE_PLACEMENT_KEY_PATTERN = /^[a-z0-9]+(?:[._][a-z0-9]+)*$/;
